import React from 'react';
import { Box, Typography, Container, Breadcrumbs, Link } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';

const InnerPageBanner = ({ title, breadcrumbs }) => {
    return (
        <Box>
            {/* Banner Section */}
            <Box
                sx={{
                    bgcolor: '#757575',
                    color: 'white',
                    py: 8,
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '350px',
                }}
            >
                <Typography variant="h4" component="h1" fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
                    {title}
                </Typography>
            </Box>

            {/* Breadcrumb Section */}
            <Box sx={{ bgcolor: '#1a1a1a', py: 1.5 }}>
                <Container maxWidth="lg">
                    <Breadcrumbs
                        separator={<NavigateNextIcon fontSize="small" sx={{ color: 'white' }} />}
                        aria-label="breadcrumb"
                        sx={{ color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <Link
                            underline="hover"
                            sx={{ display: 'flex', alignItems: 'center', color: 'white' }}
                            href="/"
                        >
                            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                            Home
                        </Link>
                        {breadcrumbs && breadcrumbs.map((item, index) => (
                            item.link ? (
                                <Link
                                    key={index}
                                    underline="hover"
                                    sx={{ color: 'white' }}
                                    href={item.link}
                                >
                                    {item.label}
                                </Link>
                            ) : (
                                <Typography
                                    key={index}
                                    sx={{ color: 'primary.main' }}
                                >
                                    {item.label}
                                </Typography>
                            )
                        ))}
                        {!breadcrumbs && (
                            <Typography
                                sx={{ color: 'primary.main' }}
                            >
                                {title}
                            </Typography>
                        )}
                    </Breadcrumbs>
                </Container>
            </Box>
        </Box>
    );
};

export default InnerPageBanner;
